import { LanguageSelectorSidebar } from "@/components/General/LanguageSelector/languageSelectorSidebar.container";
import { AccountLinks } from "@/components/General/Sidebar/components/accountLinks/accountLinks";
import { Assortiment } from "@/components/General/Sidebar/components/assortiment/assortiment";
import { InnerHtml } from "@/components/General/Sidebar/components/innerHtml";
import { Base } from "@/components/General/Sidebar/sidebar.base";

export const Sidebar = Object.assign(Base, {
    Assortiment: Assortiment,
    InnerHtml: InnerHtml,
    AccountLinks: AccountLinks,
    LanguageSelector: LanguageSelectorSidebar
});
